import Condition from "../../Classes/Condition";
import Rule from "../../Classes/Rule";
import { ruleModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    ruleToAdd: new Rule(),
    ruleToAddConditionsAll: [],
    ruleToAddConditionsAny: [],
    ruleToAddName: "",
    ruleToAddEventType: "",
    conditionDisabled: true
}

export default function ruleModalSlice(state = initialState, action) {
    switch (action.type) {
        case ruleModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case ruleModalSliceDispatch.setRuleToAdd: {
            return {
                ...state,
                ruleToAdd: action.payload
            }
        }
        case ruleModalSliceDispatch.setRuleToAddConditionsAll: {
            return {
                ...state,
                ruleToAddConditionsAll: action.payload
            }
        }
        case ruleModalSliceDispatch.setRuleToAddConditionsAny: {
            return {
                ...state,
                ruleToAddConditionsAny: action.payload
            }
        }
        case ruleModalSliceDispatch.setRuleToAddName: {
            return {
                ...state,
                ruleToAddName: action.payload
            }
        }
        case ruleModalSliceDispatch.setRuleToAddEventType: {
            return {
                ...state,
                ruleToAddEventType: action.payload
            }
        }
        case ruleModalSliceDispatch.setConditionDisabled: {
            return {
                ...state,
                conditionDisabled: action.payload
            }
        }
        case ruleModalSliceDispatch.setIsAddingCondition: {
            return {
                ...state,
                isAddingCondition: action.payload
            }
        }
        case ruleModalSliceDispatch.setSelectedCondition: {
            return {
                ...state,
                selectedCondition: action.payload
            }
        }
        default:
            return state
    }
}
